/**
 * Class component based on:
 * https://dev.to/megazear7/the-vanilla-javascript-component-pattern-37la
 */
import {
  selectDoc,
  selectArr
} from "../utils/utils";

export class Video {
  /**
   * Account constructor
   * @param container
   */
  constructor(container) {
    if (selectDoc(container)) {
      this.init();
    }
  }

  /**
   * Initialize class
   */
  init() {
    this.props();
    this.initYTVideo();
  }

  /**
   * Initialize class props
   */
  props() {
    this.videoSections = selectArr(".video-section");
  }

  /**
   *
   */
  initYTVideo() {
    let videoId,
      self = this,
      tag = document.createElement("script"),
      firstScriptTag = document.getElementsByTagName("script")[0],
      player;

    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let apiInterval = setInterval(function () {
      if (typeof YT !== "undefined") {
        try {
          self.videoSections.map((videoSection) => {

            /*if (window.innerWidth < 600) {
              videoId = selectDoc("#ytidmobile", videoSection);
            } else {
              videoId = selectDoc("#ytid", videoSection);
            }*/

            videoId = selectDoc("#ytid", videoSection);

            let videoContainer = selectDoc(".video-container", videoSection);
            if (videoContainer) {
              player = new YT.Player(videoContainer.id, {
                videoId: videoId ? videoId.value : "",
                playerVars: {
                  autoplay: 1,
                  controls: 0,
                  mute: 1,
                  loop: 1,
                  showinfo: 0,
                  rel: 0,
                  fs: 0,
                  playlist: videoId ? videoId.value : "",
                  modestbranding: 1,
                  frameborder: 0,
                  playsinline: 1,
                },
                origin: "http://verlas.com",
                events: {
                  onReady: function (e) {
                    e.target.playVideo();
                    e.target.mute();
                  },
                },
              });
            }
          });

          clearInterval(apiInterval);
        } catch (e) {
          console.log(e);
        }
      }
    }, 200);
  }
}
